
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class ExchangeItemsGrid extends Serenity.EntityGrid<ExchangeItemsRow, any> {
        protected getColumnsKey() { return 'Retail.ExchangeItems'; }
        protected getDialogType() { return ExchangeItemsDialog; }
        protected getIdProperty() { return ExchangeItemsRow.idProperty; }
        protected getInsertPermission() { return ExchangeItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return ExchangeItemsRow.localTextPrefix; }
        protected getService() { return ExchangeItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        } 
    }
}